import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal, WritableSignal} from '@angular/core';
import { FormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputText } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { InputGroup } from "primeng/inputgroup";
import { InputGroupAddon } from "primeng/inputgroupaddon";
import { EntityEtiquette } from '../../models/entity-etiquette.model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[],
  imports: [CommonModule, FormsModule, InputText, Button, InputGroup, InputGroupAddon],
  selector: 'spike-etiquette-form',
  templateUrl: './etiquette-form.html'
})
export class EtiquetteFormComponent{
  etiquette = input.required<EntityEtiquette>();
  onSave = output<EntityEtiquette>();
  onDelete = output<EntityEtiquette>();
  public shortDescription: WritableSignal<string> = signal('');

  public isValid = computed(() => {
    const shortDescription = this.shortDescription();
    return !!shortDescription && shortDescription.length >= 3 && shortDescription.length <= 50;
  });

  setupInitializer = effect(() => {
    const etiquette = this.etiquette();
    const initialDescription= etiquette ? etiquette.shortDescription ||'': '';
    this.shortDescription.set(initialDescription);
  });

  buildEtiquette(){
    this.etiquette().shortDescription= this.shortDescription();
    return this.etiquette();
  }
}
